import PropTypes from 'prop-types';

import Text from '../Text/Text';

/**
 * Info Center post's title.
 *
 * @param {Object} props
 */
function PostTitle({ children }) {
  return (
    <Text component="h1" fontSize={3.2} fontWeight={500} gutterBottom serifFont>
      {children}
    </Text>
  );
}

PostTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PostTitle;
